import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-nav-logo',
    templateUrl: './nav-logo.component.html',
    styleUrls: ['./nav-logo.component.scss'],
})
export class NavLogoComponent implements OnInit {
    @Input() navCollapsed: boolean;
    /* eslint-disable @angular-eslint/no-output-on-prefix */
    @Output() onNavCollapse = new EventEmitter();
    public windowWidth: number;

    constructor() {
        this.windowWidth = window.innerWidth;
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit(): void {}

    navCollapse(): void {
        if (this.windowWidth >= 992) {
            this.navCollapsed = !this.navCollapsed;
            this.onNavCollapse.emit();
        }
    }
}
